// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  projects: {
    name: 'projects-desktop',
    componentName: 'ProjectsContainer',
    chunk: () => import(
      /* webpackChunkName: "projects-desktop" */
      './pages/projects/ProjectsContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/projects/ProjectsContainer.js')).ProjectsContainer
        : currentRouteName === 'projects-desktop'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProjectsContainer })));
    },
    path: '/:context?/projects',
    channel: 'desktop',
  },
  projectsMobile: {
    name: 'projects-mobile',
    componentName: 'ProjectsMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "projects-mobile" */
      './pages/projects/ProjectsMobileContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/projects/ProjectsMobileContainer.js'))
          .ProjectsMobileContainer
        : currentRouteName === 'projects-mobile'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProjectsMobileContainer })));
    },
    path: '/:context?/projects',
    channel: 'mobile',
  },
  projectDetails: {
    name: 'project-details',
    componentName: 'ProjectDetailsContainer',
    chunk: () => import(
      /* webpackChunkName: "project-details" */
      './pages/projectDetails/ProjectDetailsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/projectDetails/ProjectDetailsContainer.js')).ProjectDetailsContainer
        : currentRouteName === 'project-details'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProjectDetailsContainer })));
    },
    path: '/:context?/projects/:projectId',
    channel: 'desktop'
  },
  projectDetailsMobile: {
    name: 'project-details-mobile',
    componentName: 'ProjectDetailsMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "project-details-mobile" */
      './pages/projectDetails/ProjectDetailsMobileContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/projectDetails/ProjectDetailsMobileContainer.js')).ProjectDetailsMobileContainer
        : currentRouteName === 'project-details-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ProjectDetailsMobileContainer })));
    },
    path: '/:context?/projects/:projectId',
    channel: 'mobile'
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }
});
